import { Routes } from '@angular/router';
import { GoalsIndividualComponent } from '@app/goals/goals-components/goals-individual/goals-individual.component';
import { CanDeactivateGuard } from '@app/shared/auth/can-deactivate.guard';
import { RoleApplicationMessages } from '../locale/role-application.messages';
import { RoleApplicationDetailsComponent } from '../page/role-application-details/role-application-details.component';

export const RoleApplicationDetailsRoutes: Routes = [
  {
    path: ':id',
    component: RoleApplicationDetailsComponent,
    canDeactivate: [
      CanDeactivateGuard
    ],
    data: {
      label: RoleApplicationMessages.ROLE_APPLICATION_DETAILS
    },
    children: [
      {
        path: 'goals/individual/:id',
        canActivate: [],
        component: GoalsIndividualComponent,
      }
    ]
  }
];
